import { gql } from 'graphql-request'
import { fragmentMaskShapeQuery } from '../fragments/mask-shape'

export const GlobalProgrammePageQuery = gql`
  query GlobalProgrammePage(
    $locale: LocaleInputType!
    $isPreview: Boolean! = false
  ) {
    ProgrammePage(locale: $locale, draft: $isPreview) {
      title
      description
      content {
        ... on ProgrammeTypeItem {
          id
          blockType
          programmeType {
            id
            title
            slug
            type
          }
          maskShape ${fragmentMaskShapeQuery}
          description
          marginLeft
          marginRight
          marginTop
          marginBottom
          marginLeftMobile
          marginRightMobile
          marginTopMobile
          marginBottomMobile
        }
      }
    }
  }
`
